import React, { useState } from 'react';
import { Box, Modal, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ZoomInIcon from '@mui/icons-material/ZoomIn';

const ExpandableCard = ({ children, modalWidth, modalHeight, sx: sxProp }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      {/* Contenedor original con botón de expansión */}
      <Box 
        sx={{ 
          position: 'relative',
          cursor: 'pointer',
          ...sxProp,
          '&:hover .expand-button': {
            opacity: 1
          }
        }}
        onClick={handleOpen}
      >
        <IconButton
          className="expand-button"
          sx={{
            position: 'absolute',
            top: 4,
            right: 4,
            zIndex: 10,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            color: 'white',
            opacity: 0.7,
            transition: 'opacity 0.3s',
            pointerEvents: 'none',
            padding: '2px',
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.7)',
              opacity: 1
            }
          }}
        >
          <ZoomInIcon sx={{ fontSize: 14 }} />
        </IconButton>
        {children}
      </Box>

      {/* Modal expandido */}
      <Modal
        open={open}
        onClose={handleClose}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backdropFilter: 'blur(4px)'
        }}
      >
        <Box
          sx={{
            position: 'relative',
            width: modalWidth ?? { xs: '95vw', md: '50vw' },
            height: modalHeight ?? { xs: '95vh', md: '50vh' },
            backgroundColor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            p: 3,
            overflow: 'auto',
            outline: 'none'
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <IconButton
            onClick={handleClose}
            sx={{
              position: 'absolute',
              top: 8,
              right: 8,
              zIndex: 1000,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              color: 'white',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.7)'
              }
            }}
          >
            <CloseIcon />
          </IconButton>
          <Box sx={{ width: '100%', height: '100%' }}>
            {children}
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default ExpandableCard;
